import SolutionModel from '@/dex-shared/models/SolutionModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  solutionById: (state: any, getters: any) => (solutionId: number) => {
    let solution = state.solutions[solutionId];
    if (solution) {
      return new SolutionModel(solution, getters);
    } else {
      return {};
    }
  },
  contentsBySolutionId: (state: any, getters: any) => (solutionId: number) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.solutionId === solutionId);
  },
};
